import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@coreui/coreui/dist/css/coreui.min.css';
import useAuthViewModel from './viewmodels/AuthViewModel';
import ApiDocView from './views/ApiDocView';
import DashboardView from './views/DashboardView';
import ForgotPasswordView from './views/ForgotPasswordView';
import LoginView from './views/LoginView';
import ResetPasswordView from './views/ResetPasswordView';

const PrivateRoute = ({ children }) => {
  const { email } = useAuthViewModel();
  return email ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route path="/forgot_password" element={<ForgotPasswordView />} />
        <Route path="/reset_password" element={<ResetPasswordView />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardView />
            </PrivateRoute>
          }
        />
        <Route
          path="/apidoc"
          element={
            <PrivateRoute>
              <ApiDocView />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
